import NotActiveinitialInfo from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveinitialInfo.svg?react';
import NotActiveContact from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveContact.svg?react';
import ActiveContact from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeContact.svg?react';
import ActiveinitialInfo from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeinitialInfo.svg?react';
import { StepType } from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper.type';
export const OwnerStepsData: StepType[] = [
  {
    label: 'اطلاعات پایه',
    icon: <NotActiveinitialInfo />,
    activeIcon: <ActiveinitialInfo />,
    path: 'owner-info',
  },
  {
    label: 'اطلاعات تماس',
    icon: <NotActiveContact />,
    activeIcon: <ActiveContact />,
    path: 'owner-contact-info',
  },
];
